<template>
  <SectionWrapper sectionId="core-value" class="coreValue" :class="coreValueLayoutStylingClass">
    <SectionContainer>
      <Heading :titleImgSrc="headingData.img" :titleText="headingData.text" :leading="headingData.leading" :description="headingData.description" />
      <ContentContainer>
        <dl class="coreValue_container">
          <div class="coreValue_item" v-for="(coreValue, index) in coreValueList" :key="index">
            <dt class="coreValue_item_img">
              <img :src="coreValue.img" alt="" width="182" height="182">
            </dt>
            <dd class="coreValue_item_title">{{ coreValue.title }}</dd>
            <dd class="coreValue_item_description">{{ coreValue.description }}</dd>
          </div>
        </dl>
      </ContentContainer>
    </SectionContainer>
  </SectionWrapper>
</template>

<script>
import Heading from '../atoms/Heading'
import SectionWrapper from '../atoms/SectionWrapper'
import SectionContainer from '../atoms/SectionContainer'
import ContentContainer from '../atoms/ContentContainer'

export default {
  name: 'corevalue',
  components: {
    Heading,
    SectionWrapper,
    SectionContainer,
    ContentContainer
  },
  props: {
    visibleMovie: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      headingData: {
        img: require('@/assets/images/title_corevalue.svg'),
        text: 'core value',
        leading: 'コアバリュー',
        description: '新しい事業やプロダクトの開発に伴走します。一緒にアイデアを考え、プロトタイプを開発し、検証することで、ロケットブースターのようにプロジェクトを後押しします。同時に、テクノロジーと融合したビジネスを内製する基盤づくりを支援します。'
      },
      coreValueList: [
        {
          img: require('@/assets/images/valueicon_ux.svg'),
          title: 'UXデザイン',
          description: '未来を解像度高く描きます。そのうえでユーザーや顧客の目線でビジネスをデザインし、体験価値を高めます。'
        },
        {
          img: require('@/assets/images/valueicon_cloud.svg'),
          title: 'クラウドネイティブ\nアーキテクチャ',
          description: '柔軟性のある技術基盤でモダンアプリケーションの設計や開発、自動化を実現。品質を担保しながら内製できる状態をつくります。'
        },
        {
          img: require('@/assets/images/valueicon_agile.svg'),
          title: 'アジャイルアプローチ',
          description: '発想、実行、検証のサイクルを俊敏にまわすことで、アイデアを少ない投資で市場にリリースできる基盤を築きます。'
        }
      ]
    }
  },
  computed: {
    coreValueLayoutStylingClass () {
      return this.visibleMovie ? 'coreValue--large' : ''
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/variables';
@import '../../assets/stylesheets/mixins';

.coreValue {
  &--large {
    @include bpOnlyPc() {
      padding-top: calc(600px / 2);
    }
    @include bpOnlySp() {
      padding-top: calc(300px / 2);
    }
  }
  &_container {
    display: flex;
    @include bpOnlyPc() {
      flex-direction: row;
      justify-content: space-between;
    }
    @include bpOnlySp() {
      flex-direction: column;
      align-items: center;
    }
  }
  &_item {
    max-width: 270px;
    &:not(:first-of-type) {
      @include bpOnlyPc() {
        margin-left: 24px;
      }
      @include bpOnlySp() {
        margin-top: 56px;
      }
    }
    &_img {
      text-align: center;
    }
    &_title {
      @include bpOnlyPc() {
        height: calc(20px * 1.3 * 2);
        margin-top: 32px;
      }
      @include bpOnlySp() {
        margin-top: 8px;
      }
      font-size: 20px;
      font-weight: 500;
      line-height: 1.3;
      text-align: center;
      letter-spacing: 0.02em;
      white-space: pre-wrap;
    }
    &_description {
      @include bpOnlyPc() {
        margin-top: 20px;
      }
      @include bpOnlySp() {
        margin-top: 16px;
      }
      font-size: 16px;
      line-height: 1.7;
      color: $buildNavy;
      letter-spacing: 0.105em;
      text-align: left;
    }
  }
}
</style>
